import { Typography } from "@mui/material";
import { getTitle } from "../../../utils/titleUtils";
import { AppTypographyProps } from "../../../interfaces/common/ui/IAppTitleTypographyProps";

const AppTitleTypography: React.FC<AppTypographyProps> = ({
  text,
  maxLength,
  className = "",
  variant = "body1",
}) => {
  return (
    <Typography
      className={className}
      variant={variant}
      title={getTitle(text, maxLength)}
    >
      {text}
    </Typography>
  );
};

export default AppTitleTypography;
